/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoggedRouteImport } from './routes/_logged'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as LoggedIndexRouteImport } from './routes/_logged/index'
import { Route as RecoveryTokenRouteImport } from './routes/recovery.$token'
import { Route as LoggedReportsRouteImport } from './routes/_logged/reports'
import { Route as LoggedNrgkickTransactionsRouteImport } from './routes/_logged/nrgkick-transactions'
import { Route as LoggedUsersRouteRouteImport } from './routes/_logged/users/route'
import { Route as LoggedParkRouteRouteImport } from './routes/_logged/park/route'
import { Route as LoggedUsersIndexRouteImport } from './routes/_logged/users/index'
import { Route as LoggedChargemapIndexRouteImport } from './routes/_logged/chargemap/index'
import { Route as LoggedUsersCreateRouteImport } from './routes/_logged/users/create'
import { Route as LoggedAccountEditRouteImport } from './routes/_logged/account/edit'
import { Route as LoggedUsersIdRouteRouteImport } from './routes/_logged/users/$id/route'
import { Route as LoggedUsersIdIndexRouteImport } from './routes/_logged/users/$id/index'
import { Route as LoggedParkParkIdIndexRouteImport } from './routes/_logged/park/$parkId/index'
import { Route as LoggedUsersIdEditRouteImport } from './routes/_logged/users/$id/edit'

const LoggedRoute = LoggedRouteImport.update({
  id: '/_logged',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoggedIndexRoute = LoggedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LoggedRoute,
} as any)
const RecoveryTokenRoute = RecoveryTokenRouteImport.update({
  id: '/recovery/$token',
  path: '/recovery/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const LoggedReportsRoute = LoggedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => LoggedRoute,
} as any)
const LoggedNrgkickTransactionsRoute =
  LoggedNrgkickTransactionsRouteImport.update({
    id: '/nrgkick-transactions',
    path: '/nrgkick-transactions',
    getParentRoute: () => LoggedRoute,
  } as any)
const LoggedUsersRouteRoute = LoggedUsersRouteRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => LoggedRoute,
} as any)
const LoggedParkRouteRoute = LoggedParkRouteRouteImport.update({
  id: '/park',
  path: '/park',
  getParentRoute: () => LoggedRoute,
} as any)
const LoggedUsersIndexRoute = LoggedUsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LoggedUsersRouteRoute,
} as any)
const LoggedChargemapIndexRoute = LoggedChargemapIndexRouteImport.update({
  id: '/chargemap/',
  path: '/chargemap/',
  getParentRoute: () => LoggedRoute,
} as any)
const LoggedUsersCreateRoute = LoggedUsersCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => LoggedUsersRouteRoute,
} as any)
const LoggedAccountEditRoute = LoggedAccountEditRouteImport.update({
  id: '/account/edit',
  path: '/account/edit',
  getParentRoute: () => LoggedRoute,
} as any)
const LoggedUsersIdRouteRoute = LoggedUsersIdRouteRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => LoggedUsersRouteRoute,
} as any)
const LoggedUsersIdIndexRoute = LoggedUsersIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LoggedUsersIdRouteRoute,
} as any)
const LoggedParkParkIdIndexRoute = LoggedParkParkIdIndexRouteImport.update({
  id: '/$parkId/',
  path: '/$parkId/',
  getParentRoute: () => LoggedParkRouteRoute,
} as any)
const LoggedUsersIdEditRoute = LoggedUsersIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => LoggedUsersIdRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof LoggedIndexRoute
  '/park': typeof LoggedParkRouteRouteWithChildren
  '/users': typeof LoggedUsersRouteRouteWithChildren
  '/nrgkick-transactions': typeof LoggedNrgkickTransactionsRoute
  '/reports': typeof LoggedReportsRoute
  '/recovery/$token': typeof RecoveryTokenRoute
  '/login/': typeof LoginIndexRoute
  '/users/$id': typeof LoggedUsersIdRouteRouteWithChildren
  '/account/edit': typeof LoggedAccountEditRoute
  '/users/create': typeof LoggedUsersCreateRoute
  '/chargemap/': typeof LoggedChargemapIndexRoute
  '/users/': typeof LoggedUsersIndexRoute
  '/users/$id/edit': typeof LoggedUsersIdEditRoute
  '/park/$parkId/': typeof LoggedParkParkIdIndexRoute
  '/users/$id/': typeof LoggedUsersIdIndexRoute
}
export interface FileRoutesByTo {
  '/park': typeof LoggedParkRouteRouteWithChildren
  '/nrgkick-transactions': typeof LoggedNrgkickTransactionsRoute
  '/reports': typeof LoggedReportsRoute
  '/recovery/$token': typeof RecoveryTokenRoute
  '/': typeof LoggedIndexRoute
  '/login': typeof LoginIndexRoute
  '/account/edit': typeof LoggedAccountEditRoute
  '/users/create': typeof LoggedUsersCreateRoute
  '/chargemap': typeof LoggedChargemapIndexRoute
  '/users': typeof LoggedUsersIndexRoute
  '/users/$id/edit': typeof LoggedUsersIdEditRoute
  '/park/$parkId': typeof LoggedParkParkIdIndexRoute
  '/users/$id': typeof LoggedUsersIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_logged': typeof LoggedRouteWithChildren
  '/_logged/park': typeof LoggedParkRouteRouteWithChildren
  '/_logged/users': typeof LoggedUsersRouteRouteWithChildren
  '/_logged/nrgkick-transactions': typeof LoggedNrgkickTransactionsRoute
  '/_logged/reports': typeof LoggedReportsRoute
  '/recovery/$token': typeof RecoveryTokenRoute
  '/_logged/': typeof LoggedIndexRoute
  '/login/': typeof LoginIndexRoute
  '/_logged/users/$id': typeof LoggedUsersIdRouteRouteWithChildren
  '/_logged/account/edit': typeof LoggedAccountEditRoute
  '/_logged/users/create': typeof LoggedUsersCreateRoute
  '/_logged/chargemap/': typeof LoggedChargemapIndexRoute
  '/_logged/users/': typeof LoggedUsersIndexRoute
  '/_logged/users/$id/edit': typeof LoggedUsersIdEditRoute
  '/_logged/park/$parkId/': typeof LoggedParkParkIdIndexRoute
  '/_logged/users/$id/': typeof LoggedUsersIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/park'
    | '/users'
    | '/nrgkick-transactions'
    | '/reports'
    | '/recovery/$token'
    | '/login/'
    | '/users/$id'
    | '/account/edit'
    | '/users/create'
    | '/chargemap/'
    | '/users/'
    | '/users/$id/edit'
    | '/park/$parkId/'
    | '/users/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/park'
    | '/nrgkick-transactions'
    | '/reports'
    | '/recovery/$token'
    | '/'
    | '/login'
    | '/account/edit'
    | '/users/create'
    | '/chargemap'
    | '/users'
    | '/users/$id/edit'
    | '/park/$parkId'
    | '/users/$id'
  id:
    | '__root__'
    | '/_logged'
    | '/_logged/park'
    | '/_logged/users'
    | '/_logged/nrgkick-transactions'
    | '/_logged/reports'
    | '/recovery/$token'
    | '/_logged/'
    | '/login/'
    | '/_logged/users/$id'
    | '/_logged/account/edit'
    | '/_logged/users/create'
    | '/_logged/chargemap/'
    | '/_logged/users/'
    | '/_logged/users/$id/edit'
    | '/_logged/park/$parkId/'
    | '/_logged/users/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LoggedRoute: typeof LoggedRouteWithChildren
  RecoveryTokenRoute: typeof RecoveryTokenRoute
  LoginIndexRoute: typeof LoginIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_logged': {
      id: '/_logged'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LoggedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_logged/': {
      id: '/_logged/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LoggedIndexRouteImport
      parentRoute: typeof LoggedRoute
    }
    '/recovery/$token': {
      id: '/recovery/$token'
      path: '/recovery/$token'
      fullPath: '/recovery/$token'
      preLoaderRoute: typeof RecoveryTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_logged/reports': {
      id: '/_logged/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof LoggedReportsRouteImport
      parentRoute: typeof LoggedRoute
    }
    '/_logged/nrgkick-transactions': {
      id: '/_logged/nrgkick-transactions'
      path: '/nrgkick-transactions'
      fullPath: '/nrgkick-transactions'
      preLoaderRoute: typeof LoggedNrgkickTransactionsRouteImport
      parentRoute: typeof LoggedRoute
    }
    '/_logged/users': {
      id: '/_logged/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof LoggedUsersRouteRouteImport
      parentRoute: typeof LoggedRoute
    }
    '/_logged/park': {
      id: '/_logged/park'
      path: '/park'
      fullPath: '/park'
      preLoaderRoute: typeof LoggedParkRouteRouteImport
      parentRoute: typeof LoggedRoute
    }
    '/_logged/users/': {
      id: '/_logged/users/'
      path: '/'
      fullPath: '/users/'
      preLoaderRoute: typeof LoggedUsersIndexRouteImport
      parentRoute: typeof LoggedUsersRouteRoute
    }
    '/_logged/chargemap/': {
      id: '/_logged/chargemap/'
      path: '/chargemap'
      fullPath: '/chargemap/'
      preLoaderRoute: typeof LoggedChargemapIndexRouteImport
      parentRoute: typeof LoggedRoute
    }
    '/_logged/users/create': {
      id: '/_logged/users/create'
      path: '/create'
      fullPath: '/users/create'
      preLoaderRoute: typeof LoggedUsersCreateRouteImport
      parentRoute: typeof LoggedUsersRouteRoute
    }
    '/_logged/account/edit': {
      id: '/_logged/account/edit'
      path: '/account/edit'
      fullPath: '/account/edit'
      preLoaderRoute: typeof LoggedAccountEditRouteImport
      parentRoute: typeof LoggedRoute
    }
    '/_logged/users/$id': {
      id: '/_logged/users/$id'
      path: '/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof LoggedUsersIdRouteRouteImport
      parentRoute: typeof LoggedUsersRouteRoute
    }
    '/_logged/users/$id/': {
      id: '/_logged/users/$id/'
      path: '/'
      fullPath: '/users/$id/'
      preLoaderRoute: typeof LoggedUsersIdIndexRouteImport
      parentRoute: typeof LoggedUsersIdRouteRoute
    }
    '/_logged/park/$parkId/': {
      id: '/_logged/park/$parkId/'
      path: '/$parkId'
      fullPath: '/park/$parkId/'
      preLoaderRoute: typeof LoggedParkParkIdIndexRouteImport
      parentRoute: typeof LoggedParkRouteRoute
    }
    '/_logged/users/$id/edit': {
      id: '/_logged/users/$id/edit'
      path: '/edit'
      fullPath: '/users/$id/edit'
      preLoaderRoute: typeof LoggedUsersIdEditRouteImport
      parentRoute: typeof LoggedUsersIdRouteRoute
    }
  }
}

interface LoggedParkRouteRouteChildren {
  LoggedParkParkIdIndexRoute: typeof LoggedParkParkIdIndexRoute
}

const LoggedParkRouteRouteChildren: LoggedParkRouteRouteChildren = {
  LoggedParkParkIdIndexRoute: LoggedParkParkIdIndexRoute,
}

const LoggedParkRouteRouteWithChildren = LoggedParkRouteRoute._addFileChildren(
  LoggedParkRouteRouteChildren,
)

interface LoggedUsersIdRouteRouteChildren {
  LoggedUsersIdEditRoute: typeof LoggedUsersIdEditRoute
  LoggedUsersIdIndexRoute: typeof LoggedUsersIdIndexRoute
}

const LoggedUsersIdRouteRouteChildren: LoggedUsersIdRouteRouteChildren = {
  LoggedUsersIdEditRoute: LoggedUsersIdEditRoute,
  LoggedUsersIdIndexRoute: LoggedUsersIdIndexRoute,
}

const LoggedUsersIdRouteRouteWithChildren =
  LoggedUsersIdRouteRoute._addFileChildren(LoggedUsersIdRouteRouteChildren)

interface LoggedUsersRouteRouteChildren {
  LoggedUsersIdRouteRoute: typeof LoggedUsersIdRouteRouteWithChildren
  LoggedUsersCreateRoute: typeof LoggedUsersCreateRoute
  LoggedUsersIndexRoute: typeof LoggedUsersIndexRoute
}

const LoggedUsersRouteRouteChildren: LoggedUsersRouteRouteChildren = {
  LoggedUsersIdRouteRoute: LoggedUsersIdRouteRouteWithChildren,
  LoggedUsersCreateRoute: LoggedUsersCreateRoute,
  LoggedUsersIndexRoute: LoggedUsersIndexRoute,
}

const LoggedUsersRouteRouteWithChildren =
  LoggedUsersRouteRoute._addFileChildren(LoggedUsersRouteRouteChildren)

interface LoggedRouteChildren {
  LoggedParkRouteRoute: typeof LoggedParkRouteRouteWithChildren
  LoggedUsersRouteRoute: typeof LoggedUsersRouteRouteWithChildren
  LoggedNrgkickTransactionsRoute: typeof LoggedNrgkickTransactionsRoute
  LoggedReportsRoute: typeof LoggedReportsRoute
  LoggedIndexRoute: typeof LoggedIndexRoute
  LoggedAccountEditRoute: typeof LoggedAccountEditRoute
  LoggedChargemapIndexRoute: typeof LoggedChargemapIndexRoute
}

const LoggedRouteChildren: LoggedRouteChildren = {
  LoggedParkRouteRoute: LoggedParkRouteRouteWithChildren,
  LoggedUsersRouteRoute: LoggedUsersRouteRouteWithChildren,
  LoggedNrgkickTransactionsRoute: LoggedNrgkickTransactionsRoute,
  LoggedReportsRoute: LoggedReportsRoute,
  LoggedIndexRoute: LoggedIndexRoute,
  LoggedAccountEditRoute: LoggedAccountEditRoute,
  LoggedChargemapIndexRoute: LoggedChargemapIndexRoute,
}

const LoggedRouteWithChildren =
  LoggedRoute._addFileChildren(LoggedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  LoggedRoute: LoggedRouteWithChildren,
  RecoveryTokenRoute: RecoveryTokenRoute,
  LoginIndexRoute: LoginIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
